import React from "react";

function EducationItem({education, onEdit, onDelete}) {
    const startDate = new Date(education.startDate);
    const monthStartYear = startDate.toLocaleString('default', {month: 'long', year: 'numeric'});

    const endMonthYear = education.currentStudy
        ? 'Present'
        : new Date(education.endDate).toLocaleString('default', {month: 'long', year: 'numeric'});

    return (
        <li key={education.id} className="experience-item">
            <div className="experience-content">
                <div>
                    <strong>{education.degree}</strong> in {education.studyField} - {education.institution}
                    <br/>
                    <em>{education.town}</em>
                    <br/>
                    {monthStartYear} - {endMonthYear}
                    <br/>
                </div>
                <div className="experience-actions">
                    <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(education)}></i>
                    <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(education)}></i>
                </div>
            </div>
        </li>
    );
}

export default EducationItem;
